import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useRef } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { useStableObject } from '../../util/use-stable-object';
// Store

export var createPostOfficeRouteStore = function createPostOfficeRouteStore(_ref) {
  var routeSubscriber = _ref.routeSubscriber,
    initialUrl = _ref.initialUrl;
  var state = initializeState({
    initialUrl: initialUrl
  });
  var handleUpdate = function handleUpdate(routeChange) {
    var _routeChange$next;
    var next = (_routeChange$next = routeChange.next) === null || _routeChange$next === void 0 ? void 0 : _routeChange$next.toString();
    if (next === state.current) {
      return;
    }
    state = {
      previous: state.current,
      current: next
    };
  };
  var subscribe = function subscribe(next) {
    return routeSubscriber(function (routeChange) {
      handleUpdate(routeChange);
      next();
    });
  };
  var getSnapshot = function getSnapshot() {
    return state;
  };
  return {
    subscribe: subscribe,
    getSnapshot: getSnapshot
  };
};
var usePostOfficeRouteStore = function usePostOfficeRouteStore(_ref2) {
  var subscribe = _ref2.subscribe,
    getSnapshot = _ref2.getSnapshot;
  var route = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return useStableObject(route);
};
var initialState = {
  previous: undefined,
  current: undefined
};
var initializeState = function initializeState(_ref3) {
  var initialUrl = _ref3.initialUrl;
  return _objectSpread(_objectSpread({}, initialState), {}, {
    current: initialUrl ? initialUrl === null || initialUrl === void 0 ? void 0 : initialUrl.toString() : undefined
  });
};

// Context

export var PostOfficeRouteContext = /*#__PURE__*/createContext(initialState);
export var PostOfficeRouteProvider = function PostOfficeRouteProvider(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded);
  var ref = useRef();
  if (!ref.current) {
    ref.current = createPostOfficeRouteStore(props);
  }
  var route = usePostOfficeRouteStore(ref.current);
  return /*#__PURE__*/React.createElement(PostOfficeRouteContext.Provider, {
    value: route
  }, children);
};
export var usePostOfficeRoute = function usePostOfficeRoute() {
  return useContext(PostOfficeRouteContext);
};

//Route listener